import lessRequire from '../../../../config/less-require-resolver';
import React from 'react';
import PropTypes from 'prop-types';
import DOMPurifyCreate from 'dompurify';
const DOMPurify = DOMPurifyCreate(window);

import ModalBox from '../../../shared/modal';

import classname from 'classname';

lessRequire('modules/offers/components/popups/rules.less');

const Rules = props => {
	const className = classname({
		'ReactModal__Content': true,
		'ReactModal__Content--after-open': true,
		'modal-overlay__content': true,
		'rules-modal': true,
		'campaign-rules-modal': true
	});

	return (
		<ModalBox
			body={ModalBody(props)}
			isOpen={true}
			onClose={() => props.toggleRulesPopup()}
			title={`${props.intl('Добавление потока на')} «${props.selectedOffer.title}»`}
			className={className}
		/>
	);
};

Rules.propTypes = {
	shouldShowRules: PropTypes.bool,
	selectedOffer: PropTypes.object,
	toggleRulesPopup: PropTypes.func,
	intl: PropTypes.func
};

const ModalBody = (props) => {
	const isEverad = process.env.CPA_ENV === 'everad';

	return (
		<div className="rules-body">
			<div className="info clearfix">
				<p className='font-proxima-nova-regular'>
					<i>
						{/* eslint-disable-next-line max-len */}
						{props.intl('Добавив поток на указанный вами оффер, Вы автоматически согласны с нижеприведенными правилами')}
					</i>
				</p>
			</div>
			<div className="rule-wrap">
				{ isEverad ? getRawRules(props.geo_rules) : getRules(props.geo_rules) }
			</div>
			<div className="control-btn">
				{ addButtons(props) }
			</div>
		</div>
	);
};

ModalBody.propTypes = {
	intl: PropTypes.func,
	selectedOffer: PropTypes.object
};

const addButtons = props => (<div>
	<input
		id={'join_offer'}
		type="submit" form="streamForm"
		className="button yellow-btn font-proxima-nova-semibold"
		onClick={() => {
			props.formSubmit();
			props.toggleRulesPopup();
		}}
		value={props.intl('Принять')}
	/>
	<button
		className="button cancel font-proxima-nova-semibold"
		onClick={props.toggleRulesPopup}
	>
		{props.intl('Отклонить')}
	</button>
</div>
);

addButtons.propTypes = {
	formSubmit: PropTypes.func,
	offerInfo: PropTypes.object,
	user: PropTypes.object,
	affiliateLevels: PropTypes.object,
	toggleRulesPopup: PropTypes.func,
	intl: PropTypes.func
};

// functions
const getRawRules = rules => {
	return (
		<div  className="campaign__rules" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(rules)}}>
		</div>
	);

};
const getRules = rules => {
	if (!rules) return '';
	const rawData = rules.split('\n\n');

	if (rawData.length > 3) {
		return (
			<div className="rule-wrap__item">
				<h3 className="font-proxima-nova-semibold">{rawData[0]}</h3>
				<ul>
					{ rawData.slice(1).map((text, i) => (
						<li key={i}><p>{text}</p></li>
					)) }
				</ul>
			</div>
		);
	}
	return <span className="rule">{rules}</span>;
};
export default Rules;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/streams/components/popups/rules.js